import React from 'react'
import circle from '../../assets/ellipse.svg'
// import './customer.css'

const Customer = () => {
  return (
      <section className='bg-primary h-[56px]'>
          <marquee scrollamount="10" behavior="scroll" width="100%" direction="left">
            <div className='marquee h-full flex items-center justify-center text-white'>
                
                  <p className=' flex mt-4 items-center h-[24px] w-fit text-[16px] text-center leading-[24px] tracking-[0.005em]'><img  className='mr-[8.50px]' src={circle} alt="/" />
                  Dear Esteemed customer Kpoikpoimingi Investment Limited will never ask you to reveal your personal banking details, be careful of fradulent activities</p>
         
            </div>
        </marquee>
      </section>
   
  )
}

export default Customer